import { FormObjType } from "DataTypes/Form";
import DateTime from "Utils/DateTime";

export const InsuranceForm: FormObjType[] = [
  {
    id: "companyName",
    label: "Company Name",
    placeholder: "Enter Company Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "planName",
    label: "Plan Name",
    placeholder: "Enter Plan Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "policyNumber",
    label: "Policy Number",
    placeholder: "Enter Policy Number",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "effectiveDate",
    label: "Effective Date",
    placeholder: "Select Effective Date",
    boxType: "date",
    boxSize: 3,
    validatetype: "date",
    enableFormLoad: true,
    maxVal: DateTime.CurrentDate()
  },
  {
    id: "expirationDate",
    label: "Expiration Date",
    placeholder: "Select Expiration Date",
    boxType: "date",
    boxSize: 3,
    validatetype: "date",
    enableFormLoad: true,
    maxVal: DateTime.CurrentDate()
  },
  {
    id: "priority",
    label: "Priority",
    placeholder: "Select priority",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
    readOnly: true
  },
]